import { isPlatformServer } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ConfigService, Customer, CustomerAuthService, LogoService, StorageService } from 'src/app/main';

@Component({
    selector: 'app-guanabara-header',
    templateUrl: './guanabara-header.component.html',
    encapsulation: ViewEncapsulation.None
})
export class GuanabaraHeaderComponent implements OnInit, AfterViewInit {
    isMobile: boolean = false;
    displayCustomerMenu: boolean = false;
    loggedCustomer: Customer;
    id: any = '';

    constructor(
        private logoService: LogoService,
        private router: Router,
        private appStorage: StorageService,
        private changeRef: ChangeDetectorRef,
        public customerAuthService: CustomerAuthService,
        @Inject(PLATFORM_ID) private platform: any,
        private configService: ConfigService
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.collapseBurger();
            }
        })
    }

    ngOnInit() {
        let companiesIds = this.configService.company.locationsCompanies.split(',').map(m => parseInt(m.trim()));
        this.logoService.getCompanyLogo(companiesIds).subscribe(({logos}) => {
            for (const logo of logos) {
                this.appStorage.setCompanyLogo(logo.companyId, logo);
            }
        })

        this.checkIfMobile();
    }

    ngAfterViewInit() {
        this.loggedCustomer = this.appStorage.getLoggedCustomer();
        this.displayCustomerMenu = this.loggedCustomer ? true : false;
        this.changeRef.detectChanges();
    }

    openAccordionItem(id){
        this.id = (this.id == id) ? '' : id;
    }

    collapseBurger = (): void => {
        if (isPlatformServer(this.platform)) {
            return;
        }

        let header = document.querySelector('.mobile-header-menu');
        for (let className of (<any>header).classList) {
            if (className.includes('menu-opened')) {
                this.onBurgerClicked();
                break;
            }
        }
    }

    onBurgerClicked = (): void => {
        let header = document.querySelector('.mobile-header-menu');
        header.classList.toggle('menu-opened');
    }

    getHeaderClass = (): string => {
        const size = this.router.url.split('/').length;

        if (this.router.url.includes('meuspedidos')
            || this.router.url.includes('cadastro')
            || this.router.url.includes('minhaconta')
            || this.router.url.includes('gratuidade')
            || this.router.url.includes('login')
            || this.router.url.includes('recuperar')
            || this.router.url.includes('motorista')
        ) {
            return 'user-area';
        }
        else if (
            this.router.url.includes('termos')
            || this.router.url.includes('privacidade')
            || this.router.url.includes('sobre-nos')
            || this.router.url.includes('horarios')
            || this.router.url.includes('servicos')
            || this.router.url.includes('fretamento')
            || this.router.url.includes('faq')
            || this.router.url.includes('aluguel')
        ) {
            return 'static-color';
        } else if (size < 4 || this.router.url === '/onibus') {
            if (this.router.url.includes('checkout') || this.router.url.includes('conclusion')
            ) {
                return 'on-sale';
            } else {
                return 'static-image';
            }
        } else if (this.router.url.includes('onibus')) {
            return 'on-sale';
        } else {
            return '';
        }
    }

    logout = (): void => {
        this.appStorage.setLoggedCustomer(null, this.router);
    }

    desktopLogoStyles = {
        'width': '170.4px',
        'height': '48px'
    };
    
    mobileLogoStyles = {
        'width': '106.5px',
        'height': '30px'
    };

    checkIfMobile() {
        this.isMobile = window.innerWidth <= 768;
    }
}
